var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Put this at the start and end of an inline component to work around this Chromium bug:
import { Box, Link } from "@mui/material";
import { useContext } from "react";
import { Transforms } from "slate";
import { ReactEditor, useSelected, useSlate, } from "slate-react";
import { Tooltip } from "../../../../../Atoms";
import { Context } from "../../../context";
import { getLinkSelectionData } from "../../../helpers";
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
var InlineChromiumBugfix = function () { return (_jsxs("span", __assign({ contentEditable: false, style: { fontSize: 0 } }, { children: ["$", String.fromCodePoint(160) /* Non-breaking space */] }))); };
var LinkComponent = function (_a) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    var _b = useContext(Context), setLinkData = _b.setLinkData, setLinkDialog = _b.setLinkDialog;
    var editor = useSlate();
    var selected = useSelected();
    var linkElement = element;
    /**
     * trigger edit dialog when link is clicked
     */
    var editLink = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var path, linkData;
        return __generator(this, function (_a) {
            event.preventDefault();
            path = ReactEditor.findPath(editor, element);
            // select element so editor knows what to replace
            Transforms.select(editor, path);
            linkData = getLinkSelectionData(editor);
            setLinkData(linkData);
            setLinkDialog(true);
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(Link, __assign({ href: linkElement.link, onClick: editLink }, attributes, { "data-testid": "wysiwyg-link", sx: {
            boxShadow: selected ? "0 0 0 3px #ddd" : "",
            position: "relative",
        } }, { children: [_jsx(Tooltip, __assign({ contentEditable: false, wrap: false, title: linkElement.link }, { children: _jsx(Box, __assign({ position: "absolute", top: 0, left: 0, component: "span", sx: { opacity: 0 } }, { children: children })) })), _jsx(InlineChromiumBugfix, {}), children, _jsx(InlineChromiumBugfix, {})] })));
};
export default LinkComponent;
